module.exports = __webpack_public_path__ + "static/media/road.0a37deff.jpg";